/* Yarntons gold PDP — counter quick-add popup. No dependencies. */
(function () {
  function init() {
    var modal = document.getElementById('ynt-qa');
    if (!modal) return;
    var card = modal.querySelector('.ynt-qa__card');
    var elImg = modal.querySelector('[data-qa-img]');
    var elTitle = modal.querySelector('[data-qa-title]');
    var elPrice = modal.querySelector('[data-qa-price]');
    var elOpts = modal.querySelector('[data-qa-options]');
    var elAdd = modal.querySelector('[data-qa-add]');
    var elLink = modal.querySelector('[data-qa-link]');
    var data = null, sel = [], lastFocus = null;

    function refreshCount() {
      return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        document.querySelectorAll('[data-cart-count], .cart-count-bubble, .cart-bubble__text-count, .cart-bubble__count').forEach(function (el) { el.textContent = cart.item_count; });
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
      });
    }
    function post(id) {
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: Number(id), quantity: 1 }) })
        .then(function (r) { if (!r.ok) throw 0; return r.json(); });
    }
    function optValues(i) {
      var seen = [], out = [];
      data.variants.forEach(function (v) { if (seen.indexOf(v.o[i]) < 0) { seen.push(v.o[i]); out.push(v.o[i]); } });
      return out;
    }
    function availableWith(i, val) {
      return data.variants.some(function (v) {
        if (v.o[i] !== val || !v.a) return false;
        for (var j = 0; j < sel.length; j++) { if (j !== i && sel[j] && v.o[j] !== sel[j]) return false; }
        return true;
      });
    }
    function match() {
      for (var k = 0; k < data.variants.length; k++) {
        var v = data.variants[k], ok = true;
        for (var j = 0; j < sel.length; j++) { if (!sel[j] || v.o[j] !== sel[j]) ok = false; }
        if (ok) return v;
      }
      return null;
    }
    /* Image for the current selection: exact variant photo when fully chosen;
       otherwise the first variant photo consistent with what IS chosen (so
       tapping a colour swaps immediately); otherwise the product photo.
       Loaded lazily, one image at a time — nothing is preloaded. */
    function imgFor(m) {
      if (m && m.img) return m.img;
      var anySelected = sel.some(function (s) { return !!s; });
      if (anySelected) {
        for (var k = 0; k < data.variants.length; k++) {
          var v = data.variants[k], fits = true;
          for (var j = 0; j < sel.length; j++) { if (sel[j] && v.o[j] !== sel[j]) fits = false; }
          if (fits && v.img) return v.img;
        }
      }
      return data.image;
    }
    function setImg(url) {
      if (!url || elImg.getAttribute('src') === url) return;
      var pre = new Image();
      pre.onload = function () { elImg.src = url; };
      pre.onerror = function () { if (elImg.getAttribute('src') !== data.image) elImg.src = data.image; };
      pre.src = url;
    }
    function skippable(name) { return data.options.length === 1 && name === 'Title'; }
    function render() {
      elTitle.textContent = data.title;
      elLink.href = data.url;
      var m = match();
      elPrice.textContent = (m && m.p) ? m.p : data.price;
      if (!elImg.getAttribute('src')) elImg.src = data.image;
      setImg(imgFor(m));
      elImg.alt = data.title;
      elOpts.innerHTML = '';
      data.options.forEach(function (name, i) {
        if (skippable(name)) return;
        var g = document.createElement('div'); g.className = 'ynt-qa__group';
        var l = document.createElement('p'); l.className = 'ynt-qa__label';
        l.innerHTML = name + ': <b>' + (sel[i] || 'choose') + '</b>';
        g.appendChild(l);
        var w = document.createElement('div'); w.className = 'ynt-qa__chips';
        optValues(i).forEach(function (val) {
          var b = document.createElement('button'); b.type = 'button'; b.className = 'ynt-qa__chip'; b.textContent = val;
          if (sel[i] === val) b.classList.add('is-sel');
          if (!availableWith(i, val)) b.classList.add('is-na');
          b.addEventListener('click', function () { sel[i] = (sel[i] === val) ? null : val; render(); });
          w.appendChild(b);
        });
        g.appendChild(w); elOpts.appendChild(g);
      });
      var missing = null;
      for (var i2 = 0; i2 < data.options.length; i2++) {
        if (!sel[i2] && skippable(data.options[i2])) { sel[i2] = optValues(i2)[0]; }
        if (!sel[i2] && !skippable(data.options[i2])) { missing = data.options[i2]; break; }
      }
      if (missing) { elAdd.disabled = true; elAdd.textContent = 'Select ' + missing.toLowerCase(); delete elAdd.dataset.vid; }
      else {
        m = match();
        if (!m || !m.a) { elAdd.disabled = true; elAdd.textContent = 'Sold out'; delete elAdd.dataset.vid; }
        else { elAdd.disabled = false; elAdd.textContent = 'Add to cart'; elAdd.dataset.vid = m.id; }
      }
    }
    function openModal(id) {
      var s = document.querySelector('script[data-ynt-qa="' + id + '"]');
      if (!s) return;
      try { data = JSON.parse(s.textContent); } catch (e) { return; }
      sel = data.options.map(function (name, i) {
        var vals = []; data.variants.forEach(function (v) { if (vals.indexOf(v.o[i]) < 0) vals.push(v.o[i]); });
        return vals.length === 1 ? vals[0] : null;
      });
      lastFocus = document.activeElement;
      elImg.removeAttribute('src');
      render();
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      card.focus();
    }
    function closeModal() {
      modal.hidden = true;
      document.body.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    elAdd.addEventListener('click', function () {
      if (elAdd.disabled || !elAdd.dataset.vid) return;
      elAdd.disabled = true; elAdd.textContent = '…';
      post(elAdd.dataset.vid).then(function () {
        elAdd.textContent = 'Added ✓';
        refreshCount();
        setTimeout(closeModal, 900);
      }).catch(function () { elAdd.textContent = 'Try again'; elAdd.disabled = false; });
    });
    modal.addEventListener('click', function (e) { if (e.target.hasAttribute && e.target.hasAttribute('data-qa-close')) closeModal(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) closeModal(); });
    document.querySelectorAll('.ynt-gold-sock [data-open]').forEach(function (b) {
      b.addEventListener('click', function () { openModal(b.getAttribute('data-open')); });
    });
    document.querySelectorAll('.ynt-gold-sock [data-direct]').forEach(function (b) {
      b.addEventListener('click', function () {
        b.disabled = true; b.textContent = '…';
        post(b.getAttribute('data-direct')).then(function () {
          b.textContent = 'Added ✓'; refreshCount();
          setTimeout(function () { b.textContent = 'Add to cart'; b.disabled = false; }, 2600);
        }).catch(function () { b.textContent = 'Try again'; b.disabled = false; });
      });
    });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
